export class DeviceSearchItem implements IDeviceSearchItem {
    id?: string;
    title?: string | undefined;
    dateCreated?: Date;
    dateUpdated?: Date;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    deviceTypeId?: string | undefined;
    notes?: string | undefined;
    isDisabled?: boolean;
    dateLastLogin?: Date | undefined;
    dateLastPing?: Date | undefined;
    serialNumber?: string | undefined;

    constructor(data?: IDeviceSearchItem) {
        if (data) {
            for (const property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.dateUpdated = _data["dateUpdated"] ? new Date(_data["dateUpdated"].toString()) : <any>undefined;
            this.createdByPersonId = _data["createdByPersonId"];
            this.updatedByPersonId = _data["updatedByPersonId"];
            this.deviceTypeId = _data["deviceTypeId"];
            this.notes = _data["notes"];
            this.isDisabled = _data["isDisabled"];
            this.dateLastLogin = _data["dateLastLogin"] ? new Date(_data["dateLastLogin"].toString()) : <any>undefined;
            this.dateLastPing = _data["dateLastPing"] ? new Date(_data["dateLastPing"].toString()) : <any>undefined;
            this.serialNumber = _data["serialNumber"];
        }
    }

    static fromJS(data: any): DeviceSearchItem {
        data = typeof data === 'object' ? data : {};
        const result = new DeviceSearchItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["dateUpdated"] = this.dateUpdated ? this.dateUpdated.toISOString() : <any>undefined;
        data["createdByPersonId"] = this.createdByPersonId;
        data["updatedByPersonId"] = this.updatedByPersonId;
        data["deviceTypeId"] = this.deviceTypeId;
        data["notes"] = this.notes;
        data["isDisabled"] = this.isDisabled;
        data["dateLastLogin"] = this.dateLastLogin ? this.dateLastLogin.toISOString() : <any>undefined;
        data["dateLastPing"] = this.dateLastPing ? this.dateLastPing.toISOString() : <any>undefined;
        data["serialNumber"] = this.serialNumber;
        return data;
    }
}

export interface IDeviceSearchItem {
    id?: string;
    title?: string | undefined;
    dateCreated?: Date;
    dateUpdated?: Date;
    createdByPersonId?: string | undefined;
    updatedByPersonId?: string | undefined;
    deviceTypeId?: string | undefined;
    notes?: string | undefined;
    isDisabled?: boolean;
    dateLastLogin?: Date | undefined;
    dateLastPing?: Date | undefined;
    serialNumber?: string | undefined;
}